/**
* In this file contain the the LoadingBar
**/

const LoadingBar = () => {
  const role = Number(localStorage.getItem('role'));
  return (
	<>
	  <div className="loading-container">
        <div className="background-blur"></div>
        <div className={`spinner ${role===4?'admin-spinner':''}`}></div>
      </div>
	</>
  );
	
};

export default LoadingBar;